import {Injectable, OnDestroy} from '@angular/core';
import { JobImpressaoService } from './job-impressao.service';
import { ImpressaoService } from './impressao.service';
import { SocketService } from './socket.service';
import { Subscription } from 'rxjs';
import {ServidorImpressaoService} from "./servidor-impressao.service";


@Injectable({
  providedIn: 'root'
})
export class ServidorImpressaoExecutorService  implements OnDestroy{
  public executando = false;
  private subscription: Subscription;
  public servidorRegistrado: any;
  private carregando: boolean;
  private masterChangedSub: Subscription;
  // Socket
  private socketSubscription: Subscription;
  private socketSubscriptionNovoJob: Subscription;
  public jobs: Array<any> = [];
  private erro: string;
  public totalJobsPendentes = 0;
  public jobComErro = false;
  public jobNaFila = false;
  processandoJobsPendentes = false;
  constructor(
    private jobImpressaoService: JobImpressaoService,
    private impressaoService: ImpressaoService, private servidorImpressaoService: ServidorImpressaoService,
    private socketService: SocketService
  ) {
  }

  private setServidorRegistrado(){
    if(this.servidorRegistrado) return  Promise.resolve();

    return new  Promise( async (resolve: any) => {
      this.servidorRegistrado =  await this.servidorImpressaoService.getServidorRegistrado();
      resolve();
    })
  }

  async inicieServidor(){
    await this.setServidorRegistrado();

    if( this.servidorRegistrado){
      // idempotência: evita duplicar subscriptions e imprimir em dobro
      if (this.executando) return;

      this.executando = true;
      this.configureSocket();
      await this.socketService.iniciarMasterImpressao(this.servidorRegistrado.id);
      // Quando ganhar master (ex.: após F5 + expiração do lease), recarregar pendentes.
      this.masterChangedSub = this.socketService.onImpressaoMasterChanged.subscribe((isMaster: boolean) => {
        if (isMaster && this.executando) {
          this.carregueJobs().then(() => {});
        }
      });
      this.carregueJobs().then( () => { });
    }
  }

  pareServidor(){
    this.pararExecutor(true);
    this.servidorRegistrado = null;
  }


  ehUmServidorAtivo(){
    return this.servidorRegistrado != null
  }


  isMaster(){
    return this.socketService.isTabMaster();
  }

  obtenhaNome(){
    return this.servidorRegistrado?.nome
  }

  conectado(){
    return this.socketService.conectado
  }

  imprimindo(){
    return this.jobNaFila;
  }

  async getServidorRegistrado(){
    await this.setServidorRegistrado();

    return this.servidorRegistrado;
  }

  async servidorEstaConfiguradoParaImprimir(servidorImpressao: any){
    try {
      // Primeiro verificar se este computador está configurado como servidor
      await this.setServidorRegistrado();

      if (!this.servidorRegistrado) {
        console.log('Este computador não está configurado como servidor de impressão');
        return false;
      }

      // Se está configurado, verificar se há impressoras disponíveis
      const temImpressoras =
        await this.verificarDisponibilidadeImpressoras(servidorImpressao.impressoras);

      if (!temImpressoras) {
        console.log('Este computador está configurado como servidor mas não tem impressoras disponíveis');
        return false;
      }

      console.log('Este computador é um servidor de impressão ativo e configurado');
      return true;

    } catch (erro) {
      console.error('Erro ao verificar se é servidor:', erro);
      return false;
    }
  }

  // todo: mudar pra chechas impressora por impressora saber qual esta disponivel
  private async verificarDisponibilidadeImpressoras(impressoras: Array<any>): Promise<boolean> {
    try {
      const impressorasLocal: any = await this.impressaoService.listeImpressoras();



      return impressorasLocal && impressorasLocal.length > 0;
    } catch (erro) {
      console.error('Erro ao verificar impressoras:', erro);
      return false;
    }
  }

  pararExecutor(liberarMaster: boolean = true): void {
    this.executando = false;

    if (this.subscription)
      this.subscription.unsubscribe();

    if(this.socketSubscriptionNovoJob)
      this.socketSubscriptionNovoJob.unsubscribe();

    if(this.socketSubscription)
      this.socketSubscription.unsubscribe();

    if (this.masterChangedSub)
      this.masterChangedSub.unsubscribe();

    // Em refresh (F5) / teardown, preferimos manter o lease até expirar para evitar perder o master momentaneamente.
    this.socketService.pararMasterImpressao(liberarMaster).then(() => {});

    console.log('Parando executor de jobs de impressão...');
  }

  obtenhaJobsPendentes(){
     // "Pendentes" aqui significa jobs ainda na fila (não finalizados).
     // Usar status evita dependência de flags locais (ex.: job.impresso) que podem divergir em abas não-master.
     return this.jobs.filter((job: any) => job && (job.status === 'PENDENTE' || job.status === 'PROCESSANDO' ||
       job.status === 'IMPRIMINDO'));
  }

   async  processarJobsPendentes( )  {
     this.jobComErro = false;
      try {
        this.processandoJobsPendentes = true;
        for (const job_ of  this.obtenhaJobsPendentes())
          await this.processarJob(job_);
      } catch (erro) {
        console.error('Erro ao processar jobs pendentes:', erro);
      } finally {
        this.processandoJobsPendentes = false;
      }
    }

  configureSocket(): void {
    // evita duplicar subscriptions se for chamado mais de uma vez
    if (this.socketSubscription) this.socketSubscription.unsubscribe();
    if (this.socketSubscriptionNovoJob) this.socketSubscriptionNovoJob.unsubscribe();

    // Escuta mudanças na fila de impressão
    this.socketSubscription = this.socketService.on('fila_impressao_atualizada').subscribe(() => {
      console.log('[SOCKET] fila_impressao_atualizada recebido');
     // this.carregueJobs();
    });

    this.socketSubscriptionNovoJob = this.socketService.on('novo_job_impressao').subscribe(async (data: any) => {
      console.log('[SOCKET] novo_job_impressao recebido');
      if(!this.executando) return;

      if(data.servidorImpressao.id === this.servidorRegistrado.id){
        this.jobs.push(data);
        this.setTotalPendentes();
        if(!this.socketService.isTabMaster())
          await this.socketService.tenteAssumirMasterImpressao(this.servidorRegistrado.id);

        if(this.socketService.isTabMaster())
          await this.processarJob(data)
        else
          console.log('Modo leitura (sem lock no servidor), ignorar executar job');
      } else {
        console.log('job de outro servidor: ' + data.servidorImpressao.nome)
      }
    });


    this.socketService.on('job_impressao_atualizado').subscribe((data: any) => {
      console.log('[SOCKET] job_impressao_atualizado recebido');
      console.log(data)
      let jobExistente: any = this.jobs.find((item: any) => item.id === data.id)

      if(jobExistente){
        jobExistente.status = data.status;
        jobExistente.erro = data.erro;

        if(data.concluido) {
          setTimeout(() => {
            //remover jobs concluidos
            jobExistente.concluido = true;
          }, 5 * 1000)
        }
      }

      // Recalcular contadores (importante para abas não-master)
      this.setTotalPendentes();

    //  this.carregueJobs();
    });

    this.socketService.on('servidor_removido').subscribe((data: any) => {
      console.log('[SOCKET] servidor_removido recebido');
      console.log(data)
      if(data.id === this.servidorRegistrado.id){
        this.pareServidor();
      }
    });


    this.socketService.onReconectou.subscribe(() => {
      if(!this.processandoJobsPendentes)
        this.carregueJobs().then( () => { });
    })

  }

  carregueJobs() {
    if(!this.executando) return;

    this.carregando = true;

    const query: any = { servidorImpressao: this.servidorRegistrado.id, pendentes: true, order: true};

    return new Promise(async (resolve) => {
      try {
        this.jobs = await this.jobImpressaoService.listeJobs(query);
        this.setTotalPendentes();
        // Ordenar jobs por prioridade e data de criação para mostrar posição na fila
        //this.ordenarJobsPorFila();

        if (this.servidorRegistrado) {
          console.log('Este computador é um servidor de impressão ativo e configurado');
          if(!this.socketService.isTabMaster())
            await this.socketService.tenteAssumirMasterImpressao(this.servidorRegistrado.id);

          if(this.socketService.isTabMaster()){
            this.processarJobsPendentes().then(() => {
              console.log('processou jobs pendentes')
            })
          }
        } else {
          console.log('Este computador é não é um servidor de impressão ativo e configurado');
        }

        this.carregando = false;
        resolve(null);
      } catch (erro) {
        console.error('Erro ao carregar jobs:', erro);
        this.erro = 'Erro ao carregar jobs de impressão';
        this.carregando = false;
        resolve( this.erro);
      }
    })
  }

  setTotalPendentes(){
    this.totalJobsPendentes = this.obtenhaJobsPendentes().length;
    this.jobComErro = this.jobs.find((job: any) => job.erro) != null;
  }

  ordenarJobsPorFila(): void {
    // Jobs pendentes e na fila são ordenados por prioridade e data de criação
    this.jobs.sort((a, b) => {
      // Prioridade: 1 = alta, 2 = normal, 3 = baixa
      if (a.status === 'PENDENTE' && b.status === 'PENDENTE') {
        if (a.prioridade !== b.prioridade) {
          return a.prioridade - b.prioridade; // Prioridade menor = mais alta
        }
        return new Date(a.criadoEm).getTime() - new Date(b.criadoEm).getTime();
      }


      // Status não pendente/na fila vão para o final
      if (a.status === 'PENDENTE') return -1;
      if (b.status === 'PENDENTE') return 1;

      return 0;
    });
  }


  async processarJob(job: any, manual = false): Promise<void> {
    try {
      // Lock do servidor é a fonte da verdade. Se não tenho lock, não posso imprimir.
      if(!this.socketService.isTabMaster()){
        await this.socketService.tenteAssumirMasterImpressao(this.servidorRegistrado.id);
      }
      if(!this.socketService.isTabMaster()){
        console.log('Ignorando processarJob: sem lock de master no servidor');
        return;
      }

      this.jobNaFila  = true;
      job.processando = true;
      // Atualizar status para PROCESSANDO
      await this.jobImpressaoService.atualizeStatus(job.id, 'PROCESSANDO');

      // Notificar via socket
      this.socketService.emit('job_status_updated', {
        jobId: job.id,
        status: 'PROCESSANDO'
      });

      // Verificar se a impressora está disponível
      if (!job.impressora)
        throw new Error('Impressora não configurada para este job');

      if(job.produtos && typeof job.produtos === 'string')
        job.produtos  = JSON.parse(job.produtos)

      // Atualizar status para IMPRIMINDO
      await this.jobImpressaoService.atualizeStatus(job.id, 'IMPRIMINDO');

      // Executar impressão baseada no tipo
      let imprimiu = false;

      // Se perdeu o lock no meio do caminho, aborta antes de acionar o QZ.
      if(!this.socketService.isTabMaster()){
        await this.socketService.renoveMasterImpressao();
      }
      if(!this.socketService.isTabMaster()){
        throw new Error('Perdeu o lock de master antes de imprimir');
      }

      if (job.tipo === 'PEDIDO') {
        imprimiu = await this.imprimirPedido(job, manual);
       } else   if (job.tipo === 'COMANDA') {
        imprimiu = await this.imprimirComanda(job, manual);
      } else {
        throw new Error(`Tipo de impressão não suportado: ${job.tipo}`);
      }

      if (imprimiu) {
        // Atualizar status para CONCLUIDO
        job.impresso = true;
        await this.jobImpressaoService.atualizeStatus(job.id, 'CONCLUIDO');
        console.log(`Job ${job.id} impresso com sucesso`);
      } else {
        if(job.pedido && job.pedido.erroImpressao)
          job.erro = job.pedido.erroImpressao

        if(job.comanda && job.comanda.erroImpressao)
          job.erro = job.comanda.erroImpressao

        if(!job.erro)
          job.erro = 'Falha ao imprimir'

        throw new Error(job.erro);
      }
    } catch (erro) {
      job.processando = false;
      console.error(`Erro ao processar job ${job.id}:`, erro);
      // Atualizar status para ERRO
      await this.jobImpressaoService.atualizeStatus(job.id, 'ERRO', (job.erro || erro.message));
      // Notificar via socket
      this.socketService.emit('job_status_updated', {
        jobId: job.id,
        status: 'ERRO',
        erro: erro.message
      });
    } finally {
      job.processando = false;
      this.jobNaFila  = false;
      this.setTotalPendentes();
    }
  }

  async imprimirComanda(job: any, manual = false): Promise<boolean> {
    try {
      if (!job.comanda)
        throw new Error('Dados do pedido não encontrados');

      job.comanda.erroImpressao = null;

      let impressora = job.impressora;

      impressora.layout = job.layout;
      impressora.impressaoAuto = !manual;

      if(job.produtos  ) {
        impressora.produtos =  job.produtos
        impressora.impressaoAutoCategoria = !manual && !impressora.imprimirAutomatico
      }

      //garantir nao envie remoto
      delete impressora.servidorImpressao

      await this.impressaoService.imprimaQzTrayComanda(job.comanda, impressora)
    } catch (erro) {
      console.error(erro)
      job.erro  = erro.message || erro;
    } finally {
    }

    return job.comanda.impressa;
  }

  async imprimirPedido(job: any, manual = false): Promise<boolean> {
    try {
      if (!job.pedido)
        throw new Error('Dados do pedido não encontrados');

      job.pedido.erroImpressao = null;

      let impressora = job.impressora;

      impressora.layout = job.layout;
      impressora.impressaoAuto = !manual;

      if(job.produtos  ) {
         impressora.produtos =  job.produtos
         impressora.impressaoAutoCategoria = !manual && !impressora.imprimirAutomatico
      }

      //garantir nao envie remoto
      delete impressora.servidorImpressao

      await this.impressaoService.imprimaQzTray(job.pedido, impressora)
    } catch (erro) {
      job.erro  = erro.message || erro;
    } finally {
    }

    return job.pedido.impresso;
  }


  // Método para obter informações do servidor
  getServidorInfo(): any {
    return {
      computadorId: this.servidorRegistrado.computadorId,
      configurado: true,
      ativo: this.executando
    };
  }

  ngOnDestroy(): void {
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }

    // No teardown (ex.: refresh), não liberar master: deixa expirar no Redis.
    this.pararExecutor(false);
  }

  // QZ Tray
  qzNaoConectou(): boolean {
    return !this.impressaoService.qzInstalado && !this.impressaoService.conectando;
  }

  totalPendentes(){
    return this.totalJobsPendentes
  }

  private async verificarSePodeConfigurar(): Promise<boolean> {
    try {
      // Verificar se há impressoras disponíveis
      const impressoras: any = await this.impressaoService.listeImpressoras();
      return impressoras && impressoras.length > 0;
    } catch (erro) {
      console.error('Erro ao verificar se pode configurar:', erro);
      return false;
    }
  }

}
